import { render, staticRenderFns } from "./RealTimeMinuteCard.vue?vue&type=template&id=b4b550fa&scoped=true"
import script from "./RealTimeMinuteCard.vue?vue&type=script&lang=js"
export * from "./RealTimeMinuteCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4b550fa",
  null
  
)

export default component.exports